<template>
    <dx-number-box
        ref="NumberBoxRef"
        :value="value"
        :read-only="readOnly"
        :placeholder='placeholder'
        :show-spin-buttons="isSpin"
        :show-clear-button="isClear"
        :input-attr="{ style: 'text-align: right' }"
        @input="input"
        @key-up="input"
    />

</template>
<script setup>
import { DxNumberBox } from 'devextreme-vue';
import { computed, ref } from 'vue';

const emit = defineEmits(['valueChanged', 'input']);

const props = defineProps({
    value: {
        default: 0,
        required: true,
        type: [Number, null],
    },
    meta: {
        type: Object,
        default: () => {},
    },
    placeholder: {
        type: Number,
        default: () => null
    },
    readOnly: {
        type: Boolean,
        default: false,
    }
});
const NumberBoxRef = ref(null);
const previous = ref(props.value);

const isSpin = computed(() => {
    return props.meta?.spin ? props.meta?.spin : false;
});

const isClear = computed(() => {
    return props.meta?.clearButton ? props.meta?.clearButton : false;
})

const input = () => {
    let newValue;
    if (NumberBoxRef.value.instance._options._optionManager._options.text.trim() === '') {
        newValue = null;
    } else {
        newValue = Number(NumberBoxRef.value.instance._options._optionManager._options.text)
    }
    emit('input', {
        oldText: previous.value,
        newText: newValue,
    });
};

defineExpose({NumberBoxRef});
</script>

<style lang="scss" scoped>
</style>
